import { ReactComponent as TransferInProgressIcon } from 'assets/icons/transfer-in-progress.svg'
import { ToolBarButton } from 'components/ToolBarButton'

export const PharmacyTransferButton = () => {
  const handleClick = () => {
    console.info('PHARMACY TRANSFER button clicked.')
  }

  return (
    <ToolBarButton
      disabled={false}
      label="PHARMACY TRANSFER"
      icon={TransferInProgressIcon}
      tooltipText="PHARMACY TRANSFER"
      clickCallback={handleClick}
      badgeStatus="alert"
    />
  )
}
